const getCurrentClass = state => state.currentClass;
const getUserClasses = state => state.classes;
const getStudents = state => state.students;
const getInviteToastState = state => state.inviteToast;
const getClassDeleteToast = state => state.classDeleteToast;
const getAllJoinedStudent = state => state.classes.map(obj => obj.roster.filter(el => el.status)).flat().length;

export default {
  getCurrentClass,
  getUserClasses,
  getStudents,
  getInviteToastState,
  getClassDeleteToast,
  getAllJoinedStudent
};



// WEBPACK FOOTER //
// ./src/store/modules/classes/getters.js